import config from "../config/index.js";
console.log("---config.proxyLinks----",config.proxyLinks);
const globalData = {};
export function setGlobalData(key, val) {
  globalData[key] = val;
}
export function getGlobalData(key) {
  return globalData[key];
}

const DEFAULT_DEV_ENV_KEY = "test";
const DEV_ENV_KEY_STORAGE = "web_page_render_dev_env";

const testDevSiteConfig = {
  label: "测试环境",
  mockUrl: "http://xjhy.mall-test.buyagent.omszt.com:8081",
  proxyOrigin: "http://xjhy.m-shop-test.omszt.com:7888",
  proxyMallAppUrl: "http://api-test.jyshop.omszt.com:8081",
  frontServerSite: "https://wwwdsad.jiyunsir.com/api",
  qiankunSiteUrl: "//xjhy.shopmember-test.omszt.com:7888",
};

const onlineDevSiteConfig = {
  label: "线上环境",
  mockUrl: "https://cnspacebuy.com",
  proxyOrigin: "http://app-front.oms-prod-inner.omszt.com:7799/",
  proxyMallAppUrl: "http://exapi.cnspacebuyshop-prod.omszt.com/",
  frontServerSite: "https://cnspacebuy.com/api",
  qiankunSiteUrl: "//cnspacebuy.com",
};

export const devSiteConfigMap = {
  test: testDevSiteConfig,
  online: onlineDevSiteConfig,
  production: onlineDevSiteConfig,
};

function getDevEnvKeyFromBrowserStorage() {
  if (!process.client || typeof window === "undefined") {
    return "";
  }

  try {
    return String(window.localStorage.getItem(DEV_ENV_KEY_STORAGE) || "").trim();
  } catch (error) {
    return "";
  }
}

function normalizeDevEnvKey(rawKey = "") {
  const envKey = String(rawKey || "").trim();
  if (envKey && devSiteConfigMap[envKey]) {
    return envKey;
  }
  return DEFAULT_DEV_ENV_KEY;
}

export function getCurrentDevEnvKey() {
  return normalizeDevEnvKey(
    process.env.DEV_SITE_ENV
    || process.env.NUXT_PUBLIC_DEV_SITE_ENV
    || getGlobalData("devSiteEnv")
    || getDevEnvKeyFromBrowserStorage()
    || DEFAULT_DEV_ENV_KEY,
  );
}

export function setCurrentDevEnvKey(envKey = DEFAULT_DEV_ENV_KEY) {
  const normalizedEnvKey = normalizeDevEnvKey(envKey);
  setGlobalData("devSiteEnv", normalizedEnvKey);

  if (process.client && typeof window !== "undefined") {
    try {
      window.localStorage.setItem(DEV_ENV_KEY_STORAGE, normalizedEnvKey);
    } catch (error) {}
  }

  return normalizedEnvKey;
}

export function getCurrentDevSiteConfig() {
  return devSiteConfigMap[getCurrentDevEnvKey()] || devSiteConfigMap[DEFAULT_DEV_ENV_KEY];
}

export const getMockUrl = ()=>{
  if(process.env.NODE_ENV!='development'){
    return ''
  }

  return getCurrentDevSiteConfig().mockUrl || "";
}

function shouldUseServerCacheApiPrefix(requestUrl = "") {
  if (!process.client) {
    return false;
  }

  try {
    const currentOrigin = typeof window !== "undefined" && window.location
      ? window.location.origin
      : "http://localhost";
    const parsedUrl = new URL(String(requestUrl || ""), currentOrigin);
    return parsedUrl.searchParams.get("getCache") === "1";
  } catch (error) {
    return false;
  }
}

export const getPrefixUrl = (requestUrl = "")=>{
  if(typeof window!='undefined'){
    const prefixPath = shouldUseServerCacheApiPrefix(requestUrl)
      ? "/cApi/cmsadmin"
      : "/siteapi/cmsadmin";
    return `${window.location.origin}${prefixPath}`
  }else{  
    return `http://localhost:3000/siteapi/cmsadmin`;
  }
}
export const  getProxyUrl  =(isCachePrefix=false)=>{
  let prefixUrl=isCachePrefix?'/cApi':'/api'
  if(process.env.NODE_ENV!='development'){
    return "http://"+config.proxyLinks.collectionSite + prefixUrl;
  }

  return `${getCurrentDevSiteConfig().proxyOrigin || ""}${prefixUrl}`;
} 


export const  frontServerSite  =()=>{
  if(process.env.NODE_ENV!='development'){
    return "http://"+config.proxyLinks.frontServerSite;
  }

  return getCurrentDevSiteConfig().frontServerSite || "";
} 
export const getProxyMallAppUrl =()=>{
  if(process.env.NODE_ENV!='development'){
    return "http://"+config.proxyLinks.mallSite;
  }

  return getCurrentDevSiteConfig().proxyMallAppUrl || "";
} 

export function isDisabledMallSsr() {
  return !!config.disabledMallSsr;
}

export function isCmsSite() {
  return !!config.isCmsSite;
}

function safeParseJsonValue(value, fallback = {}) {
  if (!value) {
    return fallback;
  }
  if (typeof value === "object") {
    return value;
  }
  if (typeof value !== "string") {
    return fallback;
  }
  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
}

export function normalizeMallApiBaseUrl(rawUrl = "") {
  let nextUrl = String(rawUrl || "").trim();
  if (!nextUrl) {
    return "";
  }

  nextUrl = nextUrl.replace(/\/+$/, "");
  nextUrl = nextUrl.replace(/\/mall$/i, "");

  if (process.client) {
    if (window.location.protocol === "http:" && nextUrl.indexOf("https://") === 0) {
      nextUrl = nextUrl.replace("https://", "http://");
    } else if (window.location.protocol === "https:" && nextUrl.indexOf("http://") === 0) {
      nextUrl = nextUrl.replace("http://", "https://");
    }
  }

  return nextUrl.replace(/\/+$/, "");
}

export function getStoreOtherJson(storeInfo = {}) {
  const parsedOffiaccountFollowData = safeParseJsonValue(
    storeInfo?.offiaccountFollowData
      || storeInfo?.offiaccountFollowUrl
      || storeInfo?.storePageInfo?.offiaccountFollowData
      || storeInfo?.storePageInfo?.offiaccountFollowUrl,
    {},
  );

  const candidates = [
    storeInfo?.offiaccountFollowData?.otherJson,
    storeInfo?.storePageInfo?.otherJson,
    storeInfo?.otherJson,
    parsedOffiaccountFollowData?.otherJson,
    storeInfo?.storePageInfo,
  ];

  for (const candidate of candidates) {
    const parsedCandidate = safeParseJsonValue(candidate, {});
    if (parsedCandidate && typeof parsedCandidate === "object") {
      return parsedCandidate;
    }
  }

  return {};
}

export function getMallApiBaseUrlFromStoreInfo(storeInfo = {}) {
  const otherJson = getStoreOtherJson(storeInfo);
  return normalizeMallApiBaseUrl(
    otherJson?.mallApiUrl
    || storeInfo?.mallApiUrl
    || storeInfo?.storePageInfo?.mallApiUrl
    || "",
  );
}

function normalizeStoreInfoMapLookupKeys(currentServer = "") {
  const normalizedCurrentServer = String(currentServer || "").trim();
  const currentHost = normalizedCurrentServer.replace(/^https?:\/\//, "");
  const browserOrigin = process.client ? String(window.location.origin || "").trim() : "";
  const browserHost = process.client ? String(window.location.host || "").trim() : "";

  return Array.from(new Set([
    normalizedCurrentServer,
    currentHost,
    currentHost ? `http://${currentHost}` : "",
    currentHost ? `https://${currentHost}` : "",
    browserOrigin,
    browserHost,
    browserHost ? `http://${browserHost}` : "",
    browserHost ? `https://${browserHost}` : "",
  ].filter(Boolean)));
}

export function getStoreInfoDataFromMap(storeInfoDataMap = {}, currentServer = "") {
  const safeStoreInfoDataMap = storeInfoDataMap && typeof storeInfoDataMap === "object"
    ? storeInfoDataMap
    : {};

  const lookupKeys = normalizeStoreInfoMapLookupKeys(currentServer);
  for (const key of lookupKeys) {
    if (safeStoreInfoDataMap[key]) {
      return safeStoreInfoDataMap[key];
    }
  }

  const storeInfoDataList = Object.values(safeStoreInfoDataMap);
  return storeInfoDataList.length ? (storeInfoDataList[0] || {}) : {};
}

export function getMallApiBaseUrlFromStoredStoreInformation() {
  if (!process.client) {
    return "";
  }

  const storeInformation = safeParseJsonValue(window.localStorage.getItem("StoreInformation"), {});
  return getMallApiBaseUrlFromStoreInfo(storeInformation);
}

export function getMallApiBaseUrlFromStoreInfoMap(storeInfoDataMap = {}, currentServer = "") {
  const storeInfoData = getStoreInfoDataFromMap(storeInfoDataMap, currentServer);
  return getMallApiBaseUrlFromStoreInfo(storeInfoData) || getMallApiBaseUrlFromStoredStoreInformation();
}

function normalizeCurrentServerValue(rawValue = "") {
  const normalizedValue = String(rawValue || "").split(",")[0].trim();
  if (!normalizedValue) {
    return "";
  }

  try {
    const normalizedUrl = /^[a-z]+:\/\//i.test(normalizedValue)
      ? normalizedValue
      : `http://${normalizedValue}`;
    const parsedUrl = new URL(normalizedUrl);
    return String(parsedUrl.hostname || "").trim().toLowerCase();
  } catch (error) {
    return normalizedValue
      .replace(/^https?:\/\//i, "")
      .split("/")[0]
      .replace(/:\d+$/, "")
      .trim()
      .toLowerCase();
  }
}

export function getCurrentSiteHost(headers) {
  const mockUrl = getMockUrl();
  if (mockUrl) {
    return normalizeCurrentServerValue(mockUrl);
  }

  if (process.server) {
    return normalizeCurrentServerValue(
      (headers && headers["x-custom-header1"])
      || (headers && headers["x-forwarded-host"])
      || (headers && headers.host)
      || (headers && headers.referer)
    );
  }

  if (typeof window !== "undefined" && window.location) {
    return normalizeCurrentServerValue(window.location.host || window.location.origin);
  }

  return "";
}

export function isMallProxyRequest(url = "") {
  const normalizedUrl = String(url || "").trim();
  if (!normalizedUrl) {
    return false;
  }

  return [
    /^\/?mall\//i,
    /^\/?mallSite\//i,
    /^\/?storeSite\//i,
  ].some(pattern => pattern.test(normalizedUrl));
}

export function rewriteMallProxyUrl(url = "") {
  const normalizedUrl = String(url || "").trim();
  if (!normalizedUrl) {
    return normalizedUrl;
  }

  // 直连 mallApiUrl 时，把 Nuxt 里的 mallSite/storeSite 代理前缀改写成真实 mall API 路径。
  const [rawPathname, rawSearch = ""] = normalizedUrl.split("?");
  let pathname = rawPathname;

  if (/^\/?mallSite\//i.test(pathname)) {
    pathname = pathname.replace(/^\/?mallSite\//i, "/mall/");
  } else if (/^\/?storeSite\//i.test(pathname)) {
    pathname = pathname.replace(/^\/?storeSite\//i, "/store/");
  } else if (/^\/?mall\//i.test(pathname)) {
    pathname = pathname.replace(/^\/?mall\//i, "/mall/");
  }

  return rawSearch ? `${pathname}?${rawSearch}` : pathname;
}

export const getNestServerUrl = () => {
  if (process.env.NODE_ENV !== 'development') {
    return 'http://10.200.0.92:3000'
  }
  return 'http://tmyt-jy.shopmember.omszt.com:7666/api/mall/nestserver'
}


export const getQiankunSiteUrl = ()=>{
  // return "//xjhy.shopmember-test.omszt.com:7888";
 //  return "//localhost:8089";
  if(process.env.NODE_ENV!='development'){
    if(!process.client){
      return "//"+config.proxyLinks.qiankunSite;
    }else{
      
      return window.location.origin+ "/qiankun_app_wrap/"
    }
    
  }

  return process.client && window.location.hostname.indexOf('localhost') >= 0
    ? `//${window.location.hostname}:8089`
    : (getCurrentDevSiteConfig().qiankunSiteUrl || "//xjhy.shopmember-test.omszt.com:7888");
}

 

export const mockJwtMap = {
  [getPrefixUrl()]: "",
  "http://localhost:3000/cApi/cmsadmin": "",
};

export function getMockJwtByPrefixUrl(prefixUrl = "") {
  const normalizedPrefixUrl = String(prefixUrl || "").trim();
  if (!normalizedPrefixUrl) {
    return "";
  }

  const fallbackPrefixUrl = normalizedPrefixUrl.replace(
    "/cApi/cmsadmin",
    "/siteapi/cmsadmin",
  );

  return mockJwtMap[normalizedPrefixUrl]
    || mockJwtMap[fallbackPrefixUrl]
    || mockJwtMap[getPrefixUrl()]
    || "";
}

export function checkMallFetchUrl(url) {
  const normalizedUrl = String(url || "").trim();
  if (!normalizedUrl) {
    return false;
  }

  return normalizedUrl.indexOf("mall=1") >= 0
    || /^\/?mall\//i.test(normalizedUrl)
    || /^\/?mallSite\//i.test(normalizedUrl)
    || /^\/?storeSite\//i.test(normalizedUrl);
}

export function checkCollectionFetchUrl(url) {
    return url.indexOf("collection=1") >= 0;
  }
export function getToken() {
  return process.client&&window.localStorage.getItem(config.appTokenKey);
}

export function removeToken() {
  return window.localStorage.removeItem(config.appTokenKey);
}
export function setToken(val) {
  window.localStorage.setItem(config.appTokenKey, val);
}
export function getMallAppToken() {
  return process.client&&window.localStorage.getItem(config.mallAppTokenKey);
}

export function setMallAppToken(val) {
  window.localStorage.setItem(config.mallAppTokenKey, val);
}
export function removeMallAppToken(val) {
  window.localStorage.removeItem(config.mallAppTokenKey, val);
}

export function setIsErpBuyMode(isErp) {
  
  if(process.client){
    if(isErp){
      window.sessionStorage.setItem('batchBindMallOrder','1');
      window.sessionStorage.setItem('batchBindMallOrder','1');
    }else{
      window.sessionStorage.removeItem('batchBindMallOrder');
    }
  }
}

export function isErpBuyMode() {
  if(process.client){
    return !!window.sessionStorage.getItem('batchBindMallOrder');
  }else{
    return false;
  }
 
}
 

export function getCurrentServer(headers) {
  return getCurrentSiteHost(headers);
}
 
 
export const localeTo1688CountryMap = {
  "ja_JP":'jp',
  // "zh-CN":'zh',
  // "zh-TW":'zh',
  "en":'en',
  "vi_VN":'vi',
  "ja_JP":'ja',
};

 
export const isTarget_Blank = function () {
  if(process.client && isErpBuyMode() ){
      return "_self";
  }
  return "_blank"
};

export function getSafeLink(link) {
  return typeof link === "string" ? link : "";
}

export function isHttpLink(link) {
  return getSafeLink(link).indexOf("http") >= 0;
}
export default globalData;
